import React from 'react'
import "./NaverMiss.css";
import icon1 from "../images/png/icons8-facebook-50.png";
import icon2 from "../images/png/icons8-whatsapp-48.png";
import icon3 from "../images/png/icons8-linkedin-circled-50.png";
import icon4 from "../images/png/icons8-youtube-50.png";


const NeverMiss=()=>{
  return (
    <div>
        <div className='nevermiss'>
            <div className='never1'>
                <div className='colo1'>
                    <h1>Never miss a thing.</h1>
                    <div className='serch'>
                        <input type="text"  placeholder='Enter Address'/>
                        <button type="">Subscribe</button>
                    </div>
                    <h1>Be in touch</h1>
                    <div className='touch'>
                        <img src={icon1} alt=""/>
                        <img src={icon2} alt=""/>
                        <img src={icon3} alt=""/>
                        <img src={icon4} alt=""/>            
                    </div>
                </div>
                <div className='colo1'>
                    <h1>Never miss a thing.</h1>
                    <div className='services'>
                        <ul>
                            <li>services</li>
                            <li>Blog</li>
                            <li>Portfolio</li>
                        </ul>
                        <ul>
                            <li>Tutorial</li>
                            <li>Careers</li>
                            <li>Film</li>
                        </ul>
                        
                    </div>

                    
                </div>
                <div className='colo1'>
                    <h1>Never miss a thing.</h1>
                    <div className='contact'>
                        <ul>
                            <li>Contact us</li>
                            <li>Feedback</li>
                            <li>FAQ</li>
                            <li>Terms and conditions</li>
                            <li>Privacy Policy</li>
                            <li>Data Deletion Protocol</li>
                        </ul>
                        
                    </div>
                </div>
                
            </div>
            <div className='never2'>
                <p>Made By ❤️ Roopchand chauhan</p>
            </div>
            
        </div>
    </div>
  )
}
export {NeverMiss}
